import React, { useState } from "react";
import ZbizInput from "../../components/zbizInput/ZbizInput";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import * as Yup from "yup";
import { handlePostRequest } from "../../services/PostTemplate";
import { useHistory } from "react-router-dom";

const TransactionReport = () => {
  const [loading, setloading] = useState(false);
  const [loadingIcon, setloadingIcon] = useState("pi pi-save");
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [transactionReport, setTransactionReport] = useState([]);

  const today = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1); // Subtract one month from today

  const history = useHistory();

  const validationSchema = Yup.object().shape({
    fromDate: Yup.date()
      .required("From Date is required.")
      .max(Yup.ref("toDate"), "From Date cannot be greater than To Date."),
    toDate: Yup.date()
      .required("To Date is required.")
      .min(Yup.ref("fromDate"), "To Date cannot be lesser than From Date.")
      .test(
        "max-gap",
        "The date range cannot exceed 3 months.",
        function (value) {
          const { fromDate } = this.parent;
          if (fromDate && value) {
            const from = new Date(fromDate);
            const to = new Date(value);
            const diffInDays = Math.floor((to - from) / (1000 * 60 * 60 * 24));
            return diffInDays <= 92; // Ensure gap is within 92 days
          }
          return true;
        }
      ),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      fromDate: oneMonthAgo.toISOString().split("T")[0], // One month before today
      toDate: today.toISOString().split("T")[0], // Today's date
      // fromDate: new Date().toISOString().split("T")[0],
      // toDate: new Date(new Date().setMonth(new Date().getMonth() + 1)).toISOString().split("T")[0],
    },
    onSubmit: async (data) => {
      try {
        setloading(true);
        setloadingIcon("pi pi-spin pi-spinner");
        const res = await handlePostRequest(
          data,
          `zbizgateway/fileStatusCheck/fileUploadStatusCheckAll`
        );
        setTransactionReport(res?.data);
      } catch (err) {
        console.log(err);
      } finally {
        setloading(false);
        setloadingIcon("pi pi-save");
      }
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const props = {
    onChange: formik.handleChange,
    values: formik.values,
    isFormFieldValid: isFormFieldValid,
    getFormErrorMessage: getFormErrorMessage,
  };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      // Define the columns to export and their new names
      const columnMapping = {
        batchId: "Batch Id",
        companyName: "Company Name",
        fileUploadDate: "Uploaded Date",
        employeeName: "Employee Name",
        titleFetchStatus: "T24 Status",
        employeeCNIC: "Employee Cnic",
        employeeAccountNo: "Employee Account Number",
        accountNoStatus: "Account No Status",
        amount: "Amount",
        transactionCode: "Transaction Id",
        transactionDateT24: "Transaction Created Date",
        statusDescr: "Status",
        rrn: "RRN",
      };

      // Map the data to include only the specified columns with new names
      const exportData = transactionReport?.map((item) => {
        let obj = {};
        Object.keys(columnMapping).forEach((key) => {
          obj[columnMapping[key]] = item[key];
        });
        return obj;
      });

      // Convert the mapped data to a worksheet
      const worksheet = xlsx.utils.json_to_sheet(exportData && exportData);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      // Save the Excel file
      saveAsExcelFile(excelBuffer, "File Status Summary");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    });
  };

  return (
    <>
      <div className="page_header">
        <div
          className="Top__Btn"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="d_align">
            <i
              className="pi pi-arrow-circle-left mr-1"
              onClick={() => history.goBack()}
            />
            <h3 className="mod_heading">Transaction Report</h3>
          </div>
          <Button
            label="Export Excel"
            type="button"
            icon="pi pi-file-excel"
            onClick={exportExcel}
            className="p-button-success p-mr-2"
            data-pr-tooltip="XLS"
            disabled={!transactionReport.length && true}
          />
        </div>
      </div>
      <div className="card Card__Round">
        {/* <div className="Form__Header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <h1>Transaction Report</h1>
                    <Button
                        label="Export Excel"
                        type="button"
                        icon="pi pi-file-excel"
                        onClick={exportExcel}
                        className="p-button-success p-mr-2 p-mb-3"
                        data-pr-tooltip="XLS"
                        disabled={!transactionReport.length && true}
                    />
                </div> */}
        <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
          <div className="p-fluid p-formgrid p-grid">
            <div className="p-field p-col-12 p-md-6">
              <div className="p-field input_cp">
                <ZbizInput
                  type="date"
                  label="From Date"
                  keyName="fromDate"
                  {...props}
                />
              </div>
            </div>
            <div className="p-field p-col-12 p-md-6">
              <div className="p-field input_cp">
                <ZbizInput
                  type="date"
                  label="To Date"
                  keyName="toDate"
                  max={today.toISOString().split("T")[0]}
                  {...props}
                />
              </div>
            </div>
          </div>
          <div className="GenerateDown__Btn p-mt-4">
            <Button
              loading={loading}
              // icon={loadingIcon || ""}
              // iconPos="right"
              label="Search"
              className="Btn__Transparent"
              disabled={btnDisabled}
              type="submit"
            />
          </div>
        </form>
      </div>
    </>
  );
};

export default TransactionReport;
